import { ORDER_STATUS_DRAFT, orderActionStatusList } from "../common/constants";
import { AuditTrail, PageInfo, UserComment } from "./Base";

export interface IOrder {
  id: string;
  orderNumber: string;      // Order #
  fireNumber: string;       // Fire #
  crewTypeId?: number;      // Crew Type ID
  crewTypeName?: string;    // <-- Added
  crewId?: number;          // <-- Added
  crewNumber: string;       // <-- Already present
  orderBy: string;        // Ordered by
  status: number;           // Status
  orderDate: Date | null;  // Order date
  orderDatePrintable: string;
  submittedDatePrintable:string;
  requiredBy: Date | null;  // Required by
  requiredByPrintable: string;
  orderType: string;        // Order type
  orderFrom: string;      // Submitted To
  forestArea: string;
  deliveryMethod: string;
  shipTo: string;
  watchers: string;
  auditTrail: AuditTrail | null;  // Audit information
  orderItems: IOrderItem[] | undefined;
  printDateTime: string;
  submittedDate: string;
  comments: UserComment[] | undefined;
  orderingForName: string | undefined;
  orderingForEmail: string | undefined;
  orderingForPhone: string | undefined;
  isOrderingForOtherPerson: boolean;
  phoneNumber: string;
  isPersonnelOrderType: boolean;
}

export interface IOrderItem {
  id: string | undefined;
  orderId: string;
  itemName: string;
  quantityOrdered: number | undefined;
  quantityFulfilled?: number | undefined;
  isActive: string | null;
  itemType:string;
  isCrewTypeItem: boolean | undefined;
}

export interface SearchParams {
  fireNumber: any;
  orderFrom: any;
  forestArea: any;
  orderStatus: any;
  orderType: any;
  startDate: Date | null;
  endDate: Date | null;
  orderedBy:string;
  crewNumber: any; // <-- Added
}

export class Order implements IOrder {
  id: string = "";
  orderNumber: string;
  isOrderAssociatedWithFireNumber: boolean;
  fireNumber: string;
  crewTypeId: number | undefined; // <-- Already present
  crewTypeName: string | undefined; // <-- Added
  crewId: number | undefined;       // <-- Added
  crewNumber: string;               // <-- Already present
  orderBy: string;
  status: number;
  statusDesc: string;
  orderDate: Date | null;
  orderDatePrintable: string;
  submittedDatePrintable:string;
  requiredBy: Date | null;
  requiredByPrintable: string;
  orderType: string;
  orderFrom: string;
  auditTrail!: AuditTrail;
  isChecked: string | number | boolean | undefined;
  description: string = "";
  forestArea: string  = "";
  deliveryMethod: string  = "";
  shipTo: string  = "";
  watchers: string  = "";
  orderItems: IOrderItem[] = [];
  emailAddress: string;
  printDateTime: string = "";
  submittedDate: string = "";
  defaultEmails:any;
  comments: UserComment[] = [];
  orderingForName: string | undefined;
  orderingForEmail: string | undefined;
  orderingForPhone: string | undefined;
  isOrderingForOtherPerson: boolean;
  phoneNumber: string;
  isPersonnelOrderType:boolean;

  constructor(from?: Partial<Order>) {
    this.id = from?.id ?? '';
    this.orderNumber = from?.orderNumber ?? '';
    this.isOrderAssociatedWithFireNumber = from?.isOrderAssociatedWithFireNumber ?? true;
    this.fireNumber = from?.fireNumber ?? '';
    this.crewTypeId = from?.crewTypeId ?? undefined; // <-- Already present
    this.crewTypeName = from?.crewTypeName ?? undefined; // <-- Added
    this.crewId = from?.crewId ?? undefined;             // <-- Added
    this.crewNumber = from?.crewNumber ?? '';            // <-- Already present
    this.orderBy = from?.orderBy ?? '';
    this.status = from?.status ?? ORDER_STATUS_DRAFT;
    this.statusDesc = from?.statusDesc ??  orderActionStatusList.find(i => i.value === from?.status)?.label??"";
    this.orderDate = from?.orderDate ??null;
    this.orderDatePrintable = from?.orderDatePrintable ?? "";
    this.submittedDatePrintable = from?.submittedDatePrintable ?? "";
    this.requiredBy = from?.requiredBy ?? null;
    this.requiredByPrintable = from?.requiredByPrintable ?? "";
    this.orderType = from?.orderType ?? '';
    this.orderFrom = from?.orderFrom ?? '';
    this.forestArea = from?.forestArea ?? '';
    this.deliveryMethod = from?.deliveryMethod ?? 'Pickup';
    this.emailAddress=from?.emailAddress ?? '';
    this.shipTo = from?.shipTo ?? '';
    this.watchers = from?.watchers ?? '';
    this.submittedDate=from?.submittedDate ?? ''
    this.auditTrail = from?.auditTrail ?? {
      createdBy: '',
      createdDate: new Date(),
      isDeleted: false,
      lastUpdatedBy: null,
      lastUpdatedDate: new Date(),
    };
    this.orderItems = from?.orderItems ?? [];
    this.printDateTime = from?.printDateTime ?? "";
    this.comments = from?.comments ?? [];
    this.orderingForName= from?.orderingForName ?? "";
    this.orderingForEmail= from?.orderingForEmail ?? "";
    this.orderingForPhone= from?.orderingForPhone ?? "";
    this.isOrderingForOtherPerson= from?.isOrderingForOtherPerson ??false;
    this.phoneNumber = from?.phoneNumber ?? "";
    this.isPersonnelOrderType=from?.isPersonnelOrderType??false;
  }
}

export class OrderItem implements IOrderItem {
  id: string | undefined;
  orderId: string;
  itemName: string;
  quantityOrdered: number | undefined;
  quantityFulfilled?: number;
  isActive: string | null;
  itemType: string;
  isCrewTypeItem: boolean| undefined;

  constructor(from?: Partial<OrderItem>) {
    this.id = from?.id ?? undefined;
    this.orderId = from?.orderId ?? '';
    this.itemName = from?.itemName ?? '';
    this.quantityOrdered = from?.quantityOrdered ?? undefined;
    this.quantityFulfilled = from?.quantityFulfilled ?? undefined;
    this.isActive = from?.isActive ?? null;
    this.itemType = from?.itemType ?? '';
 
    this.isCrewTypeItem =from?.isCrewTypeItem ?? undefined;
  }
}

export interface OrderResponse {
  items: Order[];
  pageInfo: PageInfo;
}

export interface OrderRequest {
  orders: Order[];
}

